import styled from 'styled-components/macro'
import { BREAK_ } from 'constants'

export const Figure = styled.figure`
  display: flex;
  align-items: center;
  justify-content: center;
gap: ${({isMobile}) => isMobile ? "0" : "8px"};
  padding: 5px 8px;
  background-color: #ffffffbf;
  border-radius: 6px;
  
  svg {
    width: 30px;
    height: 30px;
  }

  ${BREAK_.md_dn} {
    svg {
      width: 30px;
      height: 30px;
    }
  }
`
export const Text = styled.text`
  font-size: 20px;
  font-weight: 900;
  fill: #000;
`
export const Group = styled.g`  
`
export const Line = styled.line`
  stroke: #000;
  stroke-width: 5px;
`
export const Circle = styled.circle`
  fill: none;
  stroke: #000;
  stroke-width: 2;
`
export const Svg = styled.svg`
`

export const Label = styled.div`
`;
